<template>
    <v-dialog max-width="640px" :fullscreen="$vuetify.breakpoint.xsOnly" v-model="show" persistent >
      <v-card class="rounded-card">
        <v-system-bar color="#607d8b" height="60px">
           <span class="headline font-weight-bold ms-2">{{title}}</span>
        </v-system-bar>
        <v-card-text>
          <v-layout wrap>
            <v-flex xs11 sm7>
              <v-select flat class="pe-1" :items="dropdown_feeds" :value="feed_id"
                v-on:change="fillFeedValues" ref="feedSelector" :readonly="feedId == ''"
                :label="$t('Feed')" :hint="$t('select a feed to add')">
              </v-select>
            </v-flex>
            <v-flex xs1 sm1 ></v-flex>
            <v-flex xs11 sm4>
              <v-text-field :label="$t('Qty') + ' (' + $t('Kg') +')'" v-model.number="purchase.transQty"></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout wrap>
            <v-flex xs12 sm6>
              <v-text-field :label="$t('Seller')" v-model="purchase.seller" :hint="$t('Vendor name')"></v-text-field>
            </v-flex>
            <v-flex v-if="$vuetify.breakpoint.smAndUp" sm1 ></v-flex>
            <v-flex xs12 sm5>
              <v-text-field :label="$t('Reference')" v-model="purchase.reference" :hint="$t('Invoice')"></v-text-field>
            </v-flex>
          </v-layout>

          <v-layout wrap>
            <v-flex xs12 sm6>
              <v-text-field :label="$t('Driver')" v-model="purchase.driver" :hint="$t('Driver name')"></v-text-field>
            </v-flex>
            <v-flex v-if="$vuetify.breakpoint.smAndUp" sm1 ></v-flex>
            <v-flex xs12 sm5>
              <v-text-field :label="$t('truck no')" v-model="purchase.truckNo" :hint="$t('Vendor name')"></v-text-field>
            </v-flex>
          </v-layout>

          <v-layout wrap>
            <v-flex xs6 sm3>
              <v-text-field :label="$t('Total Price') + ' (' + currencySymbol + ')'" v-model.number="purchase.price" :hint="$t('Total Purchase price')"></v-text-field>
            </v-flex>
            <v-flex xs1 sm1 ></v-flex>
            <v-flex xs5 sm3>
              <v-text-field :label="$t('Dry Material')+' %'" v-model.number="purchase.dryMaterial"></v-text-field>
            </v-flex>
            <v-flex xs1 sm1 ></v-flex>
            <v-flex xs5 sm4>
              <PickDate v-model="purchase.displayDate" @input="purchase.displayDate=$event" :label="$t('Delivery Time')"> </PickDate>
            </v-flex>
          </v-layout>

        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-tooltip top>
            <template v-slot:activator="{on}">
              <v-btn icon color="primary" v-on="on" @click.stop="CancelDialog" class="mx-2">
                <v-icon>mdi-cancel</v-icon>
              </v-btn>
            </template>
            <span>{{$t('Cancel') + " "+ $t('exit without saving')}}</span>
          </v-tooltip>
          <v-tooltip top>
            <template v-slot:activator="{on}">
              <v-btn icon large color="primary" v-on="on" @click.stop="SaveTrans" class="mx-2">
                <v-icon>mdi-content-save</v-icon>
              </v-btn>
            </template>
            <span>{{$t('Save transaction')}}</span>
          </v-tooltip>
        </v-card-actions>
      </v-card>
    </v-dialog>
</template>

<script>
//import _ from "lodash";
import PickDate from "../components/common/PickDate";
export default {
    name:
      "BuyFeedDialog",
    components: {
      "PickDate": PickDate
    },
    props: {
      value: Boolean,
      feedId: String
    },
    data() {
    return {
      purchase: {},
      feed_id: ""
    };
  },
  watch: {
    value: function(newVal, oldVal) {
      if (newVal && !oldVal){
        //changed to true (showing dialog)
        this.clearData();
        if (this.feedId)
          this.fillFeedValues(this.feedId);
      }
    }
  },
  computed: {
    show: {
        get () {
          return this.value
        },
        set (value) {
          this.$emit("input", value);
        }
    },
    title() {
      return this.$i18n.t('Accept Feed Delivery');
    },
    unit() {
      return this.$store.getters.getWeightUnit;
    },
    currencySymbol() {
      return this.$store.getters.getCurrencySymbol;
    },
    dropdown_feeds() {
        return this.$store.getters.getFeedsForDD;
    }
  },
methods: {
    fillFeedValues: function(event) {
      if (event) {
        const _feed = this.$store.getters.getFeed(event);
        this.feed_id = event;
        this.purchase.dryMaterial = _feed.dryMaterial;
        this.purchase.feedValue = _feed.value;
      }
    },
    clearData() {
       if (this.$refs.feedSelector)
         this.$refs.feedSelector.reset();
      this.feed_id = this.feedId;
      this.purchase = {
        transQty: 0,
        transTime: new Date().now,
        displayDate: new Date().toISOString().substr(0, 10),
        seller: "",
        driver: "",
        truckNo: "",
        reference: "",
        dryMaterial: 0,
        feedValue: 0,
        price: 0
      }
    },
    CancelDialog() {
      this.show = false;
      this.$emit("close");
    },
    SaveTrans() {
      if (this.feed_id && this.purchase.transQty) {
        this.purchase.transTime = new Date(this.purchase.displayDate);
        this.purchase.feedValue = this.purchase.price <= 0 ? this.purchase.feedValue : (this.purchase.price / this.purchase.transQty);
        this.$store.dispatch("saveTransaction", {...this.purchase, feedId: this.feed_id, type: 'purchase'}).then(() =>
        {
          this.$root.$globalSnackbar(this.$i18n.t('Transaction saved sussfully'), "success");
          this.show=false;
          this.$emit("close");
        })
        //.catch((e) => {
        .catch(() => {
          this.$root.$globalSnackbar(this.$i18n.t('Error Saving transaction'), "error");
          //console.error("Error when saving buy:", this.purchase, e);
        });
      } else {
        this.$root.$globalSnackbar(this.$i18n.t('Must select a feed and delivery qty'), "error")
      }
    },
  },
  created() {
      if (this.feedId)
        this.fillFeedValues(this.feedId);
  },
  mounted: function () {
    document.addEventListener("keydown", (e) => {
        if (this.show && e.keyCode == 27) {
          this.CancelDialog();
        }
      });
    },
}
</script>

